<template>
  <div id="app" v-cloak>
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>

  </div>
</template>

<script>

export default {
  name: "app",
  data() {
    return {
      show: false,
      chain: 0,
      info: {},
    };
  },
  methods: {},
  created() {
    this.initWallet(); // 👈 新增：初始化当前状态
    //this.setupEthereumListeners();

  },
  mounted() {
    // let self = this;
    // this.$nextTick(() => {
    //   self.$metaMask.init().then(() => {
    //     let web3 = self.$metaMask.getWeb3();
    //     self.$metaMask.getContract(web3, self.$abi);
    //   });
    // })
  },
  methods: {
    async initWallet() {
      if (!window.ethereum) return;

      try {
        const accounts = await window.ethereum.request({ method: 'eth_accounts' });
        const currentChainId = await window.ethereum.request({ method: 'eth_chainId' });

        const savedAccount = localStorage.getItem('dapp_DAB_account');
        const expectedChainId = '56';

        if (
          accounts.length > 0 &&
          accounts[0].toLowerCase() === savedAccount.toLowerCase() &&
          parseInt(currentChainId) === parseInt(expectedChainId)
        ) {
          // ✅ 状态有效，恢复登录
          this.$store.commit('SET_WALLET_ACCOUNT', accounts[0]);
          // this.$store.commit('SET_LOGGED_IN', true);

          // ✅ 自动初始化 Web3 和合约（关键！）
          await this.initWeb3AndContract();

        } else {

          console.log('钱包状态无效1', accounts.length);
          console.log('钱包状态无效2', accounts[0]);
          console.log('钱包状态无效3', savedAccount);
          console.log('钱包状态无效4', parseInt(currentChainId));
          console.log('钱包状态无效5', parseInt(expectedChainId));
          console.log('钱包状态无效6', accounts.length > 0 &&
            accounts[0] === savedAccount &&
            parseInt(currentChainId) === parseInt(expectedChainId));

          this.logout();
        }
      } catch (e) {
        console.warn('初始化钱包状态失败', e);
        this.logout();
      }
    },

    // logout 方法
    logout() {
      localStorage.removeItem('dapp_DAB_account');
      this.$store.commit('SET_WALLET_ACCOUNT', '');
      this.$store.commit('SET_WALLET_CHAIN_ID', '');
      this.$store.commit('REMOVE_TOKEN');
    },
    // App.vue 或全局 utils
    async initWeb3AndContract() {
      let self = this;
      this.$nextTick(() => {
        self.$metaMask.init().then(() => {
          let web3 = self.$metaMask.getWeb3();
          self.$metaMask.getContract(web3, self.$abi);
        });
      })
    }

    // setupEthereumListeners() {
    //   if (typeof window.ethereum === 'undefined') return;

    //   // 账号变化
    //   window.ethereum.on('accountsChanged', (accounts) => {
    //     const account = accounts[0] || '';
    //     this.$store.commit('SET_WALLET_ACCOUNT', account);
    //     // 换账号就登出（安全）
    //     this.$store.commit('removeUser');
    //     console.log('切换账号', account);
    //   });

    //   // 链变化
    //   window.ethereum.on('chainChanged', (chainId) => {
    //     this.$store.commit('SET_WALLET_CHAIN_ID', chainId);
    //     // 切链也登出（可选，根据业务）
    //     this.$store.commit('removeUser');
    //     console.log('切换链', chainId);
    //   });
    // }
  }
};
</script>

<style lang="less">
.van-dialog__header,
.van-dialog__message {
  color: #000;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 修改van-toast--loading颜色 用就打开注释改 否则忽略
// .van-toast--loading {
//   box-shadow: 0px 1vw 3vw rgba(0, 0, 0, 0.16);
//   background-color: #fff !important;
//   .van-toast__loading {
//     color: #333;
//   }
//   .van-toast__text {
//     color: #333;
//   }
// }
.van-dialog {
  background-color: #141629 !important;
  // box-shadow: 0px 3px 10px 1px rgba(255, 236, 209, 0.13);
  background: url('~@/assets/img/kuang.png') no-repeat;
  margin: 0 auto;
  background-size: 100%;
  background-position: center;
  height: 60vw;

  .van-dialog__content--isolated {
    min-height: 40vw;
  }

  .van-dialog__header {
    color: #fff;
  }

  .van-dialog__message--has-title {
    color: #fff;
  }

  .van-dialog__cancel {
    .van-button__text {
      color: #fff;
    }
  }
}
</style>
<style lang="less" scoped>
.box {
  width: 100%;
  font-size: 15px;
  text-align: center;
}
</style>